import { render, staticRenderFns } from "./products.vue?vue&type=template&id=6b0b1f84"
import script from "./products.ts?vue&type=script&lang=js&external"
export * from "./products.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports